import { Component, OnInit, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first, retry } from 'rxjs/operators';
import { CommonService } from '../service/commons-service';
import { AppConfig } from '../util';

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  baseURL: any = null;
  appConfig: AppConfig;

  public show: boolean = false;
  public inputType: any = 'Password';
  ipAddress: any = 1;
  hide: any;
  isCaptcha: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    appConfig: AppConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.appConfig = appConfig;
    this.baseURL = appConfig.getServerURL();
  }

  ngOnInit() {
    //Using for Christmas/New Year Popup
    // $('.closeMaintenanceMsg').click(function () {
    //   $('.maintenanceMsg').hide();
    //   $('.maintPopup').removeClass('modal-backdrop');
    // });
    this.getIP();
    this.generateCaptcha();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      loginas: ['self', Validators.required],
    });
  }

  toggle() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show) this.inputType = 'Text';
    else this.inputType = 'Password';
  }
  /**
   * Get the IP address.
   */
  getIP() {
    this.commonService.getIPAddress().subscribe((res: any) => {
      console.log('Ressss', res);
      this.ipAddress = res.ip;
    });
  }
  //user login with jira credential
  authenticatUser() {
    if (this.isCaptcha) {
      var string1 = this.removeSpaces(
        (<HTMLInputElement>document.getElementById('mainCaptcha')).value
      );
      var string2 = this.removeSpaces(
        (<HTMLInputElement>document.getElementById('txtInput')).value
      );
      if (string1 != string2) {
        localStorage.setItem('errorMsg', 'Please enter valid captcha');
        this.commonService.showerror();
        return;
      }
    }
    // stop here if form is invalid
    if (
      !this.loginForm.controls.username.value &&
      !this.loginForm.controls.password.value
    ) {
      localStorage.setItem('errorMsg', this.appConfig.getBlankLoginErrorMsg());
      this.commonService.showerror();
      return;
    }
    const userNameArr = this.loginForm.controls.username.value.split('@');
    const userName = userNameArr[0];
    let locIpAddr = 1;
    this.loading = true;
    this.commonService
      .login(
        userName,
        this.loginForm.controls.password.value,
        this.loginForm.controls.loginas.value,
        this.ipAddress
      )
      .pipe(first())
      .subscribe(
        (res) => {
          this.loading = false;
          if (res && res.data && res.data.length > 0) {
            console.log('Login Page', res.data);
            if (
              !res.data[0].emailAddress ||
              res.data[0].emailAddress.trim().length == 0
            ) {
              if (res.data[0].email) {
                res.data[0]['emailAddress'] = res.data[0].email;
              } else if (res.data[0].userEmail) {
                res.data[0]['emailAddress'] = res.data[0].userEmail;
              }
            }
            if (res.data[0].towerId) {
              res.data[0].towerId = res.data[0].towerId.toString();
            }
            if (
              res.data[0].towerId &&
              res.data[0].towerId.split(',').length > 1
            ) {
              res.data[0].towerIdArray = res.data[0].towerId.split(',');
              res.data[0].towerId = res.data[0].towerId.split(',')[0];
            } else {
              res.data[0].towerIdArray = [];
            }
            localStorage.setItem(
              'user',
              JSON.stringify({ userData: res.data[0] })
            );

            console.log('userdata', res.data[0]);
            if (res.data[0].userRoll == '1')
              this.router.navigate(['/adminDashboard']);
            else if (res.data[0].userRoll == '5')
              this.router.navigate(['/selfRating']);
            else this.router.navigate(['/dashboard']);
          } else if (res.error) {
            if (res.isCaptcha) {
              this.isCaptcha = res.isCaptcha;
              this.generateCaptcha();
            }
            localStorage.setItem('errorMsg', res.error);
            this.commonService.showLoginError();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem(
            'errorMsg',
            this.appConfig.getInvalidDetailsMsg()
          );
          this.commonService.showerror();
        }
      );
  }

  generateCaptcha() {
    var alpha = new Array(
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '0'
    );
    var i;
    for (i = 0; i < 6; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = alpha[Math.floor(Math.random() * alpha.length)];
      var f = alpha[Math.floor(Math.random() * alpha.length)];
    }
    var code = a + '' + b + '' + '' + c + '' + d + '' + e + '' + f;

    //  var inputValue = (<HTMLInputElement>document.getElementById("mainCaptcha")).value = code
    if (this.isCaptcha) {
      this.waitForCaptch('mainCaptcha').then((elm) => {
        var inputValue = ((<HTMLInputElement>(
          document.getElementById('mainCaptcha')
        )).value = code);
      });
    }
  }
  waitForCaptch(selector) {
    return new Promise((resolve) => {
      if (document.getElementById(selector)) {
        return resolve(document.getElementById(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.getElementById(selector)) {
          resolve(document.getElementById(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  CheckValidCaptcha() {
    if (this.isCaptcha) {
      var string1 = this.removeSpaces(
        (<HTMLInputElement>document.getElementById('mainCaptcha')).value
      );
      var string2 = this.removeSpaces(
        (<HTMLInputElement>document.getElementById('txtInput')).value
      );
      if (string1 == string2) {
        document.getElementById('success').innerHTML =
          'Form is validated Successfully';
        //alert("Form is validated Successfully");
        return true;
      } else {
        document.getElementById('error').innerHTML =
          'Please enter a valid captcha.';
        //alert("Please enter a valid captcha.");
        return false;
      }
    }
  }
  removeSpaces(string) {
    return string.split(' ').join('');
  }

  hidePopup() {
    this.hide = 'hide';
  }
}
